import React from 'react'

function MyCourses() {
  return (
    <div>MyCourses</div>
  )
}

export default MyCourses